import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Plus, FileText, ExternalLink } from "lucide-react";
import { toast } from "sonner";
import api, { apiError } from "../../../lib/api";
import { Label, EmptyState } from "../../../components/common";
import { Button } from "../../../components/ui/button";
import { fmtDateTime } from "../../../lib/time";

const STATUS = { published: "bg-emerald-100 text-emerald-700", draft: "bg-slate-100 text-slate-600", scheduled: "bg-amber-100 text-amber-700" };
export const postStatus = (p) => (p.status === "published" && p.published_at > new Date().toISOString() ? "scheduled" : p.status);

export default function PlatformBlog() {
  const [d, setD] = useState(null);
  const navigate = useNavigate();
  useEffect(() => { api.get("/platform/blog").then((r) => setD(r.data)).catch((e) => toast.error(apiError(e))); }, []);

  if (!d) return <div className="text-slate-400">Loading…</div>;
  return (
    <div className="space-y-6">
      <div className="flex flex-wrap items-end justify-between gap-3">
        <div><Label>Marketing</Label><h1 className="font-head text-2xl font-bold text-slate-900 sm:text-3xl">Insights Blog</h1>
          <p className="mt-1 text-sm text-slate-500">{d.can_publish ? "Write, publish and manage articles on servantage.co.za/insights." : "Write and edit drafts. The Master admin reviews and publishes."}</p></div>
        <div className="flex gap-2">
          <a href="/insights" target="_blank" rel="noreferrer"><Button variant="outline" data-testid="blog-view-public"><ExternalLink className="mr-1 h-4 w-4" />View blog</Button></a>
          <Button onClick={() => navigate("/app/platform/blog/new")} className="bg-[#4338CA] hover:bg-[#3730A3]" data-testid="blog-new"><Plus className="mr-1 h-4 w-4" />New article</Button>
        </div>
      </div>
      {d.posts.length === 0 ? <EmptyState icon={FileText} title="No articles yet" hint="Create your first article." /> : (
        <div className="overflow-x-auto rounded-xl border border-slate-200 bg-white">
          <table className="w-full min-w-[720px] text-sm" data-testid="blog-table">
            <thead><tr className="border-b border-slate-200 text-left text-xs uppercase tracking-wide text-slate-400">
              <th className="px-4 py-3">Title</th><th>Category</th><th>Status</th><th>Published</th><th>Updated</th></tr></thead>
            <tbody>
              {d.posts.map((p) => (
                <tr key={p.id} className="border-b border-slate-100 hover:bg-slate-50" data-testid={`blog-row-${p.id}`}>
                  <td className="px-4 py-3"><Link to={`/app/platform/blog/${p.id}`} className="font-semibold text-slate-800 hover:text-indigo-700" data-testid={`blog-edit-${p.id}`}>{p.title}</Link>
                    <p className="text-xs text-slate-400">/insights/{p.slug} · {p.reading_minutes} min</p></td>
                  <td className="text-slate-600">{p.category}</td>
                  <td><span className={`rounded-full px-2 py-0.5 text-xs font-bold capitalize ${STATUS[postStatus(p)]}`}>{postStatus(p)}</span></td>
                  <td className="text-slate-500">{p.status === "published" ? fmtDateTime(p.published_at) : "—"}</td>
                  <td className="text-slate-500">{fmtDateTime(p.updated_at)}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
